import { ActivityRecordType } from "@sp-crm/core";

const recordPrefixes: Record<ActivityRecordType, string> = {
    placement: "/clients/show/",
    homeCare: "/home-care-clients/show/",
    referenceContact: "/references/contacts/show/",
    referenceBusiness: "/references/organizations/show/",
    community: "/communities/show/",
};

export const hrefForActivityRecord = (
    recordType: ActivityRecordType,
    entityId: string,
): string => `${recordPrefixes[recordType]}${entityId}`;
